import type { BrandsTableModalsProps } from '@/components/brands-table/BrandsTableModals';
import type { BrandsTableData } from '@/components/brands-table/use-brands-table-view-model';
import type { ProductsTableModalsProps } from '@/components/products-table/ProductsTableModals';
import type { ProductsTableData } from '@/components/products-table/use-products-table-view-model';
import {
    buildDomainGroupTableControllerBindings,
    type BuildDomainGroupTableControllerBindingsArgs,
    type GroupTableControllerBindings,
    type GroupTableControllerTableBindings,
} from '@/components/group-tables/group-table-controller-bindings.builder';

export type BrandsTableControllerTableBindings = GroupTableControllerTableBindings<BrandsTableData>;

export type BrandsTableControllerBindings = GroupTableControllerBindings<
    BrandsTableControllerTableBindings,
    BrandsTableModalsProps
>;

type BrandsTableAnalysisKeys =
    | 'openedBrandGroup'
    | 'openedBrandGroupAnalysis'
    | 'isBrandGroupAnalysisLoading'
    | 'brandGroupAnalysisError'
    | 'onBrandGroupAnalysisClose';

type BuildBrandsTableControllerBindingsArgs = BuildDomainGroupTableControllerBindingsArgs<
    BrandsTableControllerTableBindings,
    BrandsTableModalsProps,
    BrandsTableAnalysisKeys
>;

export const buildBrandsTableControllerBindings = ({
    table,
    analysis,
    groupEditor,
}: BuildBrandsTableControllerBindingsArgs): BrandsTableControllerBindings =>
    buildDomainGroupTableControllerBindings({
        table,
        analysis,
        groupEditor,
    });

export type ProductsTableControllerTableBindings = GroupTableControllerTableBindings<ProductsTableData>;

export type ProductsTableControllerBindings = GroupTableControllerBindings<
    ProductsTableControllerTableBindings,
    ProductsTableModalsProps
>;

type ProductsTableAnalysisKeys =
    | 'openedProduct'
    | 'openedProductAnalysis'
    | 'isProductAnalysisLoading'
    | 'productAnalysisError'
    | 'onProductAnalysisClose'
    | 'openedProductAiResponse'
    | 'openedProductAiData'
    | 'isProductAiLoading'
    | 'productAiError'
    | 'onProductAiClose';

type BuildProductsTableControllerBindingsArgs = BuildDomainGroupTableControllerBindingsArgs<
    ProductsTableControllerTableBindings,
    ProductsTableModalsProps,
    ProductsTableAnalysisKeys
>;

export const buildProductsTableControllerBindings = ({
    table,
    analysis,
    groupEditor,
}: BuildProductsTableControllerBindingsArgs): ProductsTableControllerBindings =>
    buildDomainGroupTableControllerBindings({
        table,
        analysis,
        groupEditor,
    });
